<!-- 巨量引擎广告组 -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
	<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 0;">
			<div class="jl-screen-box">
				<a-dropdown-button @click="handleButtonClick">
				    批量操作
					<a-menu slot="overlay" @click="handleMenuClick">
						<!-- <a-menu-item key="1"> <a-icon type="align-right" />开启</a-menu-item>
						<a-menu-item key="2"> <a-icon type="align-right" />暂停</a-menu-item>
						<a-menu-item key="3"> <a-icon type="user-delete" />删除</a-menu-item> -->
					</a-menu>
				</a-dropdown-button>
			</div>
			
			<div class="jl-screen-box">
				<a-button @click="custtom_visible = true" icon="unordered-list" >自定义列</a-button>
			</div>
			
			
			<!-- <div style="display: flex;align-items: center;padding-right: 10px;"> -->
				<div class="jl-screen-box">
					<rangePicker @change-date='onChangeDate'></rangePicker>
				</div>
				
				<!-- 选择投手 -->
				<adminSelect @handle-change="handleChangeA"></adminSelect>
				
				<!-- 选择广告账户 -->
				<div class="jl-screen-box">
					<advSelect @select-adv-id="handleChangeB"></advSelect>
				</div>
				
				<!-- 选择广告计划 -->
				<div class="jl-screen-box">
					<planSelect @handle-change="handleChangeE"></planSelect>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 160px"
						placeholder="请选择计划状态"
						@change="handleChangeF"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option value="-2">不限</a-select-option>
						<a-select-option v-for="(value,key) in conditionSelect.status" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-select
						style="min-width: 110px"
						placeholder="投放状态"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
						showSearch
					  >
						<a-select-option v-for="(value,key) in conditionSelect.put_status" :key="key" :value="key">
						  {{value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_adv_id_input" placeholder="账户ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_campaign_id_input" placeholder="计划ID搜索" allowClear style="width: 190px;"/>
				</div>
				
				<div class="jl-screen-box">
					<a-input v-model="r_campaign_name" placeholder="计划名称搜索" allowClear style="width: 190px;"/>
				</div>
				
				<a-button @click="searchButton('button')" :loading="search_button_loading" class="jl-screen-box" type="primary" icon="search">搜索</a-button>
			<!-- </div> -->
		</div>
	</div>
	</div>
	
	<div style="">
		<KSjhTable @table-th-click="tableThClick" @click-Fzr="clickFzr" :rableTitle="rableTitle" 
		:tableShowData="tableShowData" :tableSumData="tableSumData" 
		:table_scroll_width="table_scroll_width" 
		:indeterminate="indeterminate" :checkAll="checkAll" :table_null_width="table_null_width" 
		@click-All-Checkbox="onCheckAllChange" @click-Checkbox="onChangeCheckbox" @sync-zhxx-click="syncZhxxClick"
		@status-Checkbox="statusCheckbox"></KSjhTable>
	</div>
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	
	
	<!-- 批量删除 -->
	<a-modal :visible="dl_modal" title="确认要删除这些吗？" okType="danger" width="700px"
	  okText="删除" cancelText="取消"
	  @ok="dlOk" @cancel="dlCancel" :confirmLoading="dl_loading">
	    <div style="">
			<div style="margin-bottom: 10px;">已选的删除项（广告组名称）：</div>
			<div style="max-height: 360px;overflow-y: auto;display: flex;align-items: center;flex-wrap: wrap;cursor: default;">
				<div v-for="(item,index) in selectedData" :key="index" style="margin-bottom: 10px;display: flex;align-items: center;margin-right: 15px;" class="">
					<div style="width: 80px;text-align: right;">id：{{item.id}}</div>
					<span style="margin: 0 5px;"> — </span>
					<div style="width: 195px;">{{item.unit_name}}</div>
				</div>
			</div>
			
			<!-- <div class="">id：4 —— 李永润</div> -->
		</div>
	</a-modal>
	
	<!-- 自定义列 -->
	<a-modal v-model="custtom_visible" width="830px" title="设置自定义列" @ok="custtom_visible = false" okText="确认" cancelText="取消" >
	    <div style="max-height:550px;overflow-y: overlay;">
			<template  v-for="(d_tem,d_ndex) in customCheckboxData">
				<div class="custom-title">
					<a-checkbox @change="checkboxCustom($event,d_tem)"
					:checked="d_tem.custom_checkbox" style="margin-right: 5px;margin-bottom:7px;"></a-checkbox>
					{{d_tem.label}}
				</div>
				<div class="custom-cell-box">
					<template v-for="(item,index) in rableTitle">
						<div v-if="(d_tem.showTitle.indexOf(item.type) > -1)" 
						:key="item.type" style="width:240px;">
							<a-checkbox @change="onChangeSJ($event,index,d_tem)"
							:checked="item.show_control" style="margin-right: 5px;margin-bottom:7px;">
								{{item.title}}
							</a-checkbox>
						</div>
					</template>
				</div>
			</template>
			
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { KSjhList, JLzhSelectGgzh , putDataMenu, putSetAdvUser, JLggzSelectGroup, JLggzEditStatus, JLggzSyncPlan} from '@/request/api'
import KSjhTable from '@/components/KStable/KSjhTable.vue'
import rangePicker from './component/rangePicker'
import adminSelect from './component/adminSelect'
import advSelect from './component/advSelect'
import planSelect from './component/planSelect'
export default {
	name: 'KSjh_',
	components: {
		KSjhTable, rangePicker, advSelect, planSelect, adminSelect
	},
	data() {
		return {
			startTime: '2023-01-01', // 投放日期-开始时间
			endTime: '2023-01-01', // 投放日期-结束时间
			
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"计划名称",width:110, sort_status:0, type:"campaign_name", text_right: false,sort_:90,sort_control: false, show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"操作",width:60, sort_status:0, type:"cz", text_right: false,sort_:88,sort_control: false, show_control: true,},
				
				{title:"投放状态",width:60, sort_status:0, type:"put_status", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"计划状态",width:70, sort_status:0, type:"status", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"当日预算",width:60, sort_status:0, type:"day_budget", text_right: false,sort_:89,sort_control: false, show_control: true,},
				{title:"计划类型",width:60, sort_status:0, type:"campaign_type", text_right: false,sort_:89,sort_control: false, show_control: false,},
				{title:"新创编标识字段",width:70, sort_status:0, type:"dsp_version", text_right: false,sort_:89,sort_control: false, show_control: false,},
				{title:"创建渠道",width:60, sort_status:0, type:"create_channel", text_right: false,sort_:89,sort_control: false, show_control: false,},
				
				{title:"花费(元)",width:85, sort_status:0, type:"cost", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"封面曝光数",width:85, sort_status:0, type:"show", text_right: true,sort_:86,sort_control: true, show_control: false,},
				{title:"封面点击数",width:85, sort_status:0, type:"photo_click", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"封面点击率",width:85, sort_status:0, type:"photo_click_ratio", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"千次展现消费",width:85, sort_status:0, type:"cpm", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"平均点击价格",width:85, sort_status:0, type:"cpc", text_right: true,sort_:87,sort_control: true, show_control: false,},
				
				{title:"素材曝光数",width:85, sort_status:0, type:"aclick", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"行为数",width:85, sort_status:0, type:"bclick", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"行为率",width:85, sort_status:0, type:"action_ratio", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"千次素材展现消费",width:85, sort_status:0, type:"click_1k_cost", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"平均行为单价",width:85, sort_status:0, type:"action_cost", text_right: true,sort_:87,sort_control: true, show_control: false,},
				{title:"3s 播放率",width:85, sort_status:0, type:"play_3s_ratio", text_right: true,sort_:87,sort_control: true, show_control: false,},
				
				{title:"激活数",width:85, sort_status:0, type:"activation", text_right: true,sort_:87,sort_control: true, show_control: true,},
				{title:"首日付费次数",width:85, sort_status:0, type:"event_pay_first_day", text_right: true,sort_:87,sort_control: true, show_control: true,},
				
				{title:"当天总充值金额",width:85, sort_status:0, type:"eff_total_pay_money", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天分成金额",width:85, sort_status:0, type:"eff_total_left_money", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充分成金额",width:85, sort_status:0, type:"eff_total_left_money_fisrt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天总ROI",width:70, sort_status:0, type:"eff_roi", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天首充ROI",width:80, sort_status:0, type:"eff_roi_first", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"落地页跳转数",width:80, sort_status:0, type:"user_click", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"跳转成本",width:80, sort_status:0, type:"lp_price", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天订单笔数",width:80, sort_status:0, type:"eff_total_order_cnt", text_right: true,sort_:35,sort_control: true, show_control: false,},
				{title:"当天充值用户数",width:90, sort_status:0, type:"eff_total_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"当天充值用户成本",width:90, sort_status:0, type:"eff_total_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"ARPU",width:80, sort_status:0, type:"arpu", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户数",width:80, sort_status:0, type:"eff_report_pay_user_cnt", text_right: true,sort_:35,sort_control: true, show_control: true,},
				{title:"回传用户成本",width:80, sort_status:0, type:"eff_report_pay_user_cost", text_right: true,sort_:35,sort_control: true, show_control: true,},
				
				{title:"推广账户ID",width:110, sort_status:0, type:"advertiser_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"计划ID",width:110, sort_status:0, type:"campaign_id", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"创建时间",width:140, sort_status:0, type:"create_time", text_right: false,sort_:35,sort_control: false, show_control: true,},
				{title:"投手",width:120, sort_status:0, type:"admin_list", text_right: false,sort_:35,sort_control: false, show_control: true,},
			],
			tableShowData: [], // 显示表格内容
			tableSumData: {}, // 总计

			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_page: 1,
			table_total: 0,
			r_limit: 50,
			r_admin_id: [], // 选择投手
			r_adv_id: [], // 选择的广告账户
			r_adv_id_input: "", // 广告账户ID精准搜索
			r_sort_field: "", // 排序参数
			r_sort_type: "", // 排序类型
			r_campaign_id_input: "", // 广告组ID精准搜索
			r_campaign_id: [],
			r_put_status: undefined,
			r_status: undefined,
			r_campaign_name: null, // 计划名称
			
			conditionSelect: {
				put_status: {
					'1': '投放中',
					'2': '暂停',
					'3': '删除',
				},
				status: {
					'1': '计划已暂停',
					'3': '计划超预算',
					'4': '有效',
					'5': '广告计划已删除',
					'6': '余额不足',
				},
			} , // 搜索条件（计划状态、投放状态）
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selectedData: [], // 选择内容存放数组
			
			// 批量删除弹窗
			dl_modal: false,
			dl_loading: false,
			
			// 自定义列
			custtom_visible: false, // 自定义列弹窗
			customCheckboxData: [ // 自定义列
				{
					label: "基础信息：",
					showTitle:['status','put_status','day_budget','campaign_type','dsp_version','create_channel'],
					custom_checkbox: false,
					type:"jc"
				},
				{
					label: "基础数据项：",
					showTitle:['cost','show','bclick','action_ratio','click_1k_cost','action_cost','aclick','photo_click','photo_click_ratio','play_3s_ratio','activation','event_pay_first_day','cpc','cpm'],
					custom_checkbox: false,
					type:"ty"
				},
				{
					label: "统计数据项：",
					showTitle:["eff_total_pay_money","eff_total_left_money","eff_total_left_money_fisrt","eff_roi","eff_roi_first","user_click","lp_price","eff_total_order_cnt","eff_total_pay_user_cnt","eff_total_pay_user_cost","arpu","eff_report_pay_user_cnt","eff_report_pay_user_cost",],
					custom_checkbox: false,
					type:"sjx"
				},
			],
		}
	},
	mounted(){
		let that = this
		
		that.search_button_loading = true
		
		// 获取表格、页面宽高信息
		that.computeTableWidth()
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		// 接收从计划页面传过来的参数
		if(this.$route.params){
			if(this.$route.params.jump_id){
				this.r_adv_id_input = this.$route.params.jump_id
				
			}
		}
		
		
		// 搜索
		that.searchButton()
			
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(dateString) {
			// console.log("日期选择",dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		handleChangeA(e){ // 选择投手
			console.log(e);
			// 未设置的选项与其他选项不可以同时选，所以这里要加限制
			if(e.length > 1 && e.indexOf('-1') > -1){
				this.$message.warning('未设置与其他选项不能同时选择');
			}
			else {
				this.r_admin_id = e
			}
		},
		handleChangeB(e){ // 选择广告账户
			console.log(e);
			this.r_adv_id = e
		},
		handleChangeE(e){ // 选择广告计划
			console.log(e);
			this.r_campaign_id = e
		},
		handleChangeF(e){ // 请选择广告状态
			console.log(e);
			this.r_status = e
		},
		handleChangeG(e){ // 投放状态
			console.log(e);
			this.r_put_status = e
		},
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			
			// 点击按钮进行条件搜索的时候，要把页数变成1，否则相关内容可能搜索不出来。
			if(type == 'button'){
				that.r_page = 1
				
				// 这个页面经常需要通过消费的排序或其他排序来看数据，所以这里清空的话，每次搜索就要重新点排序，麻烦，干脆注释
				// 排序的状态重置
				// that.r_sort_field = ''
				// that.r_sort_type = ''
				// that.rableTitle.forEach(res=>{
				// 	res.sort_status = 0 // 排序的状态重置
				// })
			}
			
			// 为了把选择账户下拉框与账户ID搜索框的数据进行整合，因为这两个请求字段是一样的
			let aaa_id = null
			if(that.r_adv_id_input && that.r_adv_id.length == 0){
				aaa_id = that.r_adv_id_input
			}
			else if(!that.r_adv_id_input && that.r_adv_id.length > 0){
				aaa_id = that.r_adv_id
			}
			else if(that.r_adv_id_input && that.r_adv_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_adv_id) // 深拷贝，不然搜索框里的值会出现下拉框，因为下拉框有:value="r_adv_id"
				let jjj = JSON.parse(iii)
				jjj.push(that.r_adv_id_input)
				aaa_id = jjj
			}
			else {
				aaa_id = that.r_adv_id
			}
			
			let ggg_id = null
			if(that.r_campaign_id_input && that.r_campaign_id.length == 0){
				ggg_id = that.r_campaign_id_input
			}
			else if(!that.r_campaign_id_input && that.r_campaign_id.length > 0){
				ggg_id = that.r_campaign_id
			}
			else if(that.r_campaign_id_input && that.r_campaign_id.length > 0){
				// 不用去重，试了下，就算传重复的，后端那边会过滤
				let iii = JSON.stringify(that.r_campaign_id) // 深拷贝，不然搜索框里的值会出现下拉框，因为下拉框有:value="r_adv_id"
				let jjj = JSON.parse(iii)
				jjj.push(that.r_campaign_id_input)
				ggg_id = jjj
			}
			
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				start_time: that.startTime.replace(/-/g, ''),
				end_time: that.endTime.replace(/-/g, ''),
				adv_id: aaa_id, // 账户id
				campaign_id: ggg_id, // 广告计划
				put_status: that.r_put_status,
				status: that.r_status,
				campaign_name: that.r_campaign_name,
			}
			// 如有排序字段就加上
			if(that.r_sort_field){ 
				r_data.order = that.r_sort_field
				r_data.sort = that.r_sort_type
			}
			// 超级管理、投放管理可以有 投手
			// if(Object.keys(that.personChargeList).length > 0){
				r_data.admin_id = that.r_admin_id // 选择投手
			// }
			KSjhList(r_data).then(res=>{
				console.log('搜索',res);
				
				// 因为批量操作的开启和暂停没有弹窗提示选了哪些内容，所以就不支持翻页也存着上一个页面存的内容
				// 每次请求重置批量选择的状态
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ // 8011表示内容为空
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false // 用于多选和单选
						res.popover_clicked = false // 表格-操作栏的气泡卡片
						if(res.status == '启用'){
							res.status_checked = true
						}
						else { // 暂停
							res.status_checked = false
						}
					})
					
					that.search_button_loading = false
					that.$message.success('搜索成功');
					that.tableSumData = res.data.data.plan_sum
					that.table_total = res.data.data.total
					that.tableShowData = data
				}
				else {

					that.search_button_loading = false
					
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
			})
			.catch(err=>{
				// 重置状态
				that.selectedData = []
				that.checkAll = false
				that.indeterminate = false
				
				that.search_button_loading = false
				
				that.$message.error('搜索失败，请检查网络状态')
			})
		},
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.r_page = e
			this.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		
		// 批量操作
		handleButtonClick(e) {
		    console.log('click left button', e);
		},
		plRequest(e){
			let that = this
			
			// 把相同adv_id的进行归类，分批次请求
			let arr = []
			this.selectedData.forEach(res=>{
				if(arr.length > 0){
					let ttt = true
					arr.forEach(res_z=>{
						if(res.adv_id == res_z){
							ttt = false
						}
					})
					if(ttt){
						arr.push(res.adv_id)
					}
				}
				else {
					arr.push(res.adv_id)
				}
			})
			
			let r_arrys = []
			arr.forEach(res=>{
				let obj = {
					o_adv_id: res,
					o_group_ids: []
				}
				this.selectedData.forEach(res_z=>{
					if(res_z.adv_id == res){
						obj.o_group_ids.push(res_z.id)
					}
				})	
				r_arrys.push(obj)
			})
			
			// console.log('r_arrys',r_arrys);
			
			
				let r_opt_status
				
				if(e.key == '1'){ // 开启
					r_opt_status = "CAMPAIGN_STATUS_ENABLE"
				}
				else if(e.key == '2'){ // 暂停
					r_opt_status = "CAMPAIGN_STATUS_DISABLE"
				}
				else if(e.key == '3'){ // 删除
					r_opt_status = "CAMPAIGN_STATUS_DELETE"
				}
				
				let promise_arr = []
				for(let i = 0; i < r_arrys.length ; i ++){
					let ppp = new Promise((resolve,reject)=>{
						JLggzEditStatus({
							adv_id: r_arrys[i].o_adv_id,
							group_ids: r_arrys[i].o_group_ids,
							opt_status: r_opt_status,
						}).then(res=>{
							console.log('开启/暂停/删除',res);
							if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){ 
								resolve('OK')
							}
							else if(res.data.code === 401){ // 未登录
								reject('err')
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else { 
								reject('err')
								that.$message.error(`其他错误：${res.data.msg}`);
							}
							
						}).catch(err=>{
							reject('err')
						})
					})
					promise_arr.push(ppp)
				}
				// console.log("promise_arr",promise_arr)
				// 等待请求全部完成
				const result = Promise.all(promise_arr).then(res=>{
					// console.log('resultresult',res);
					that.search_button_loading = false
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					if(e.key == '1'){ // 开启
						that.$message.success('开启成功');
					}
					else if(e.key == '2'){ // 暂停
						that.$message.success('暂停成功');
					}
					else if(e.key == '3'){ // 删除
						that.dl_loading = false
						that.dl_modal = false
						that.$message.success('删除成功');
					}
					
					that.searchButton()
					
				}).catch(err=>{
					that.selectedData = []
					that.tableShowData.forEach(res=>{
						res.checked = false // 重置
					})
					
					that.checkAll = false
					that.indeterminate = false
					
					that.dl_loading = false
					that.search_button_loading = false
					that.$message.error('请求失败，请刷新页面再试')
				})
				console.log("result",result); 
			
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			if(this.selectedData.length > 0){
				let that = this
				if(e.key == '1' || e.key == '2'){ // 开启
					that.search_button_loading = true
					
					// console.log(this.selectedData);
					that.plRequest(e)
				}
				
				else if(e.key == '3'){ // 删除
					this.dl_modal = true
				}
			}
			else {
				this.$message.warning('还没有选择内容');
			}
			
		},
		// 开启、暂停按钮点击
		statusCheckbox(e,item){
			console.log('qqq',e,item);
			// item.status_checked = e
			this.selectedData.push(item)
			if(item.status == '启用'){ 
				console.log('启用');
				this.plRequest({key: "2"}) // 当前为开启状态就要改为暂停状态
			}
			else { // 暂停
				console.log('暂停');
				this.plRequest({key: "1"}) // 当前为暂停状态就要改为开启状态
			}
			
		},
		
		
		
		// 点击负责人
		clickFzr(e){
			console.log(e)
			
		},
		
		
		
		// 全选
		onCheckAllChange(e){
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				
				that.indeterminate = false
				that.checkAll = true
				
			}
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
			// that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			// console.log(that.r_sort_field);
			// console.log(that.r_sort_type);
			that.r_page = 1
			that.searchButton()
		},
		
		
		// 批量删除确认
		dlOk(){
			let that = this
			
			that.dl_loading = true
			that.plRequest({key:"3"})
		},
		// 删除弹窗取消
		dlCancel(){
			if(this.dl_loading){
				return
			}
			
			this.dl_modal = false
		},
		
		// 操作
		syncZhxxClick(item,type){
			let that = this
			if(type == 2){ // 同步计划
				if(!that.search_button_loading){
					that.search_button_loading = true
					JLggzSyncPlan({
						adv_id: item.id
					}).then(res=>{
						that.search_button_loading = false
						console.log("同步计划",res);
						that.$message.success('同步计划成功');
						that.searchButton()
					})
					.catch(err=>{
						that.search_button_loading = false
					})
				}
			}
			
		},
		
		// 自定义列
		// 数据项————————
		onChangeSJ(e,index,d_tem){
			this.rableTitle[index].show_control = e.target.checked
			console.log(`checked = ${e.target.checked} + ${index}`);
			// 重新计算表格宽度
			this.computeTableWidth()
			
			// 检测子项是否都选中，子项全部选中，则父项也要跟着选中。子项有一个没有被勾选，则父项也要取消勾选
			let ccccc = true
			d_tem.showTitle.forEach(res=>{
				this.rableTitle.forEach(t_es=>{
					if(res == t_es.type && !t_es.show_control){ // 表示有勾选
						ccccc = false
					}
				})
			})
			d_tem.custom_checkbox = ccccc
		},
		// 自定义列的小标题前的选择框
		checkboxCustom(e,d_tem){
			d_tem.custom_checkbox = e.target.checked
			
			this.rableTitle.forEach(res=>{
				d_tem.showTitle.forEach(d_es=>{
					if(res.type == d_es){
						if(e.target.checked){ // 要进行选中
							res.show_control = true
						}
						else {
							res.show_control = false
						}
					}
				})
			})
			// 重新计算表格宽度
			this.computeTableWidth()
		},
		// 计算表格宽度
		computeTableWidth(){
			let that = this
			let ttt = JSON.parse(JSON.stringify(that.rableTitle))
			
			// 获取表格信息
			let table_info = this.$getTableInfo(ttt, 60)
			that.body_width = table_info.body_width
			that.table_scroll_width = table_info.table_width
			that.table_null_width = table_info.null_width
			
			setTimeout(()=>{
				// 给母页面的tab传递粘性定位用的参数
				that.$bus.$emit("stickyData", that.table_scroll_width);
			},300)
		},
	},
	
}
</script>

<style scoped>
.custom-title {
	font-size: 15px;
	font-weight: 600;
	margin-bottom: 10px;
}
.custom-cell-box {
	display:flex;
	flex-wrap: wrap;
	padding-left: 20px;
	margin-bottom:20px;
}
</style>